var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FieldText, Modal, ModalBody, ModalFoot, ModalHead, Spinner, Text, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import { analytics } from 'app/utils/segment';
import { isNumberValidWithReason } from 'app/utils/telephonyHelpers';
import styles from './externalCallerIdModal.module.scss';
import '../telephony.less';
const validate = (values) => {
    const errors = {};
    if (!values) {
        return errors;
    }
    if (values.phone_number) {
        if (typeof values.phone_number === 'string' &&
            values.phone_number.trim().length > 0) {
            const validateNumberResult = isNumberValidWithReason({
                phoneNumber: values.phone_number,
            });
            if (validateNumberResult !== true) {
                console.warn('validateNumberResult', validateNumberResult);
                errors.phone_number = validateNumberResult;
            }
        }
    }
    else {
        errors.phone_number = 'Phone number is required.';
    }
    if (!values.name) {
        errors.name = 'Name is required.';
    }
    return errors;
};
class ExternalCallerIdModalImpl extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            phone_number: '',
            extension: '',
            numberError: null,
        };
    }
    componentDidUpdate(prevProps) {
        const { isOpen: prevIsOpen, ui: { externalCallerIdModalShown: prevExternalCallerIdModalShown }, } = prevProps;
        const { isOpen, ui: { externalCallerIdModalShown }, } = this.props;
        if (prevIsOpen && !isOpen) {
            this.setState({
                phone_number: '',
                extension: '',
                numberError: null,
            });
        }
        if (prevExternalCallerIdModalShown === true &&
            externalCallerIdModalShown === false) {
            this.closeModal();
        }
    }
    handleFormSubmit(values) {
        analytics.phoneAddOutboundCallerIdFormSubmitted();
        const { verifyExternalCallerId } = this.props;
        const { extension, name, phone_number } = values;
        const payload = {
            phone_number,
            extension: extension || null,
            name: name || null,
        };
        verifyExternalCallerId(payload).catch(() => {
            /** Noop. */
        });
    }
    closeModal() {
        analytics.phoneAddOutboundCallerIdFormCancelled();
        const { onClose } = this.props;
        this.setState({
            phone_number: '',
            extension: '',
            numberError: null,
        });
        onClose();
    }
    verificationMessage(verifyPhoneNumber) {
        const { code, phone_number } = verifyPhoneNumber;
        const isWithCode = !!code;
        if (isWithCode) {
            return (_jsxs("div", Object.assign({ className: styles.verification }, { children: [_jsxs("h4", { children: ["Verify ", phone_number] }), _jsx(Text.Paragraph, { children: "You\u2019ll receive an automatic phone call within the next minute. Please enter the code below during the call to verify your phone number:" }), _jsx("h3", { children: _jsx("b", { children: code }) })] })));
        }
        return (_jsxs("div", Object.assign({ className: styles.verification }, { children: [_jsxs("h4", { children: ["Verifying ", phone_number] }), _jsx(Text.Paragraph, { children: "This number is being automatically verified. You will receive a notification, once the verification is completed." })] })));
    }
    render() {
        const { isOpen, verifyPhoneNumber, ui, handleSubmit } = this.props;
        const isVerifyNumberShown = !!ui.verifyPhoneNumberShown;
        const isLoading = status == 'loading';
        return (_jsx("form", Object.assign({ onSubmit: handleSubmit(this.handleFormSubmit) }, { children: _jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: this.closeModal }, { children: [_jsx(ModalHead, { onClose: this.closeModal, title: "Add external caller ID" }), _jsx(ModalBody, { children: _jsx("div", Object.assign({ className: "external-caller-id-modal__body" }, { children: isVerifyNumberShown ? (this.verificationMessage(verifyPhoneNumber)) : (_jsxs(_Fragment, { children: [_jsx(Field, { label: "Phone number", name: "phone_number", className: "external-caller-id-modal__phone", component: FieldText, placeholder: "e.g. +4500000000", type: "text", helpIcon: {
                                            title: 'Phone number',
                                            text: 'Add a phone number you’d like to add to your caller ID list. Your organization can use this number for making outbound calls.',
                                        }, required: true }), _jsx(Field, { label: "Name", name: "name", className: "external-caller-id-modal__name", component: FieldText, placeholder: "e.g. Customer Support", type: "text", helpIcon: {
                                            title: 'Name',
                                            text: 'Specify the name you’d like to associate with this caller ID (e.g. Customer Support, complaints, high-priority, etc.).',
                                        }, required: true }), _jsx(Field, { label: "Extension", name: "extension", className: "external-caller-id-modal__extension", component: FieldText, placeholder: "e.g. 1, 5, *, #", type: "text", helpIcon: {
                                            title: 'Extension',
                                            text: 'Specify any extensions or keypad selection to route calls through an IVR menu for this phone number.',
                                        } })] })) })) }), _jsx(ModalFoot, Object.assign({}, (!isVerifyNumberShown && {
                        cancelOnClick: this.closeModal,
                    }), { confirmName: "Verify", confirmOnClick: handleSubmit(this.handleFormSubmit), confirmProps: Object.assign({ disabled: isLoading, type: 'submit' }, (isVerifyNumberShown && {
                            isLoading: true,
                            loadingIndicator: _jsx(Spinner, { size: 16 }),
                        })) }))] })) })));
    }
}
__decorate([
    boundMethod
], ExternalCallerIdModalImpl.prototype, "handleFormSubmit", null);
__decorate([
    boundMethod
], ExternalCallerIdModalImpl.prototype, "closeModal", null);
__decorate([
    boundMethod
], ExternalCallerIdModalImpl.prototype, "verificationMessage", null);
export const ExternalCallerIdModal = reduxForm({
    form: 'ExternalCallerIdModal',
    enableReinitialize: true,
    validate,
})(ExternalCallerIdModalImpl);
